export default function HeroSection() {
  const scrollToSection = (id: string) => {
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="hero" className="relative min-h-[580px] md:min-h-[640px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20stylized%20artistic%20illustration%20of%20a%20trending%20social%20media%20entertainment%20news%20scene%20with%20warm%20coral%20and%20amber%20tones%2C%20abstract%20geometric%20shapes%20representing%20hot%20topics%20and%20viral%20content%2C%20modern%20editorial%20design%20aesthetic%2C%20soft%20gradient%20background%20with%20warm%20orange%20and%20pink%20hues%2C%20sophisticated%20magazine-style%20composition%2C%20clean%20and%20eye-catching%20layout&width=1600&height=900&seq=hero-bg-51cg&orientation=landscape"
          alt="51吃瓜黑料网 热门事件盘点 吃瓜爆料第一站"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/50"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 pt-20 md:pt-24 pb-12">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 md:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-primary-500/20 text-primary-300 text-xs font-medium mb-4 whitespace-nowrap">
              <i className="ri-fire-line text-sm"></i>
              实时热搜 · 每日更新
            </span>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-white leading-tight mb-3">
              51吃瓜黑料网
              <span className="block text-accent-300 text-xl md:text-2xl lg:text-3xl font-heading font-normal mt-1">
                吃瓜爆料第一站
              </span>
            </h1>

            <p className="text-base md:text-lg text-white/70 leading-relaxed mt-2 mb-6">
              不放过任何一个瓜，不错过任何一个热点
            </p>

            <p className="text-sm md:text-base text-white/60 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-8">
              51吃瓜黑料网汇聚全网吃瓜群众，实时盘点热门事件与最新爆料。从娱乐圈大瓜到社会热点，从网红争议到行业黑料，我们用最快的速度、最全的角度为你呈现吃瓜现场。每日更新海量一手资讯，加入网友热议，成为真正的吃瓜达人。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mb-8">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-accent-400">12,680+</div>
                <div className="text-xs text-white/50 mt-1">爆料事件</div>
              </div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-accent-400">8.6万</div>
                <div className="text-xs text-white/50 mt-1">吃瓜群众</div>
              </div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-accent-400">24h</div>
                <div className="text-xs text-white/50 mt-1">全天候更新</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <button
                onClick={() => scrollToSection('#topics')}
                className="px-8 py-3 bg-primary-500 hover:bg-primary-600 text-white font-medium rounded-full transition-colors whitespace-nowrap cursor-pointer text-sm"
              >
                立即围观热门事件
              </button>
              <button
                onClick={() => scrollToSection('#ranking')}
                className="px-8 py-3 bg-white/15 hover:bg-white/25 text-white font-medium rounded-full transition-colors whitespace-nowrap cursor-pointer text-sm backdrop-blur-sm"
              >
                查看热度榜单
              </button>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center">
            <div className="relative w-full max-w-md lg:max-w-lg">
              <div className="relative rounded-2xl overflow-hidden border-2 border-white/20 backdrop-blur-sm bg-white/5">
                <img
                  src="https://readdy.ai/api/search-image?query=A%20stylized%20editorial%20illustration%20of%20viral%20social%20media%20gossip%20and%20trending%20entertainment%20news%2C%20warm%20coral%20and%20amber%20color%20scheme%2C%20abstract%20shapes%20representing%20hot%20topics%20bubbling%20up%2C%20modern%20magazine%20cover%20aesthetic%2C%20clean%20composition%20with%20soft%20gradient%20background%2C%20eye-catching%20and%20sophisticated%20design&width=600&height=700&seq=hero-main-51cg&orientation=portrait"
                  alt="51吃瓜黑料网 吃瓜群众围观热门事件 网友热议吃瓜现场"
                  className="w-full h-auto object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}